<template>
  <div>

    <v-navigation-drawer v-if="isAuth" dark temporary :right="right" v-model="rightDrawer" app
                         class="primary" style="z-index: 5;">

      <v-flex class="gutter-mobile-header primary" />

      <v-list dark class="pa-0 primary v-toolbar" >
        <v-list-tile avatar  style="border-bottom: 1px solid rgba(255,255,255,0.12)">

          <v-list-tile-avatar v-if="hasAvatar === true" >
<!--            <v-img lazy-src="static/images/avatar180x.jpg" :src="$store.getters['user/avatar']" ></v-img>-->
            <div class="user-avatar elevation-10"
                 :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"></div>

          </v-list-tile-avatar>
          <v-list-tile-avatar v-else color="red accent-2" >
            <span class="white--text headline">{{ avatarLetters }}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title
              class="font-weight-bold"
              v-text="uname"/>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

<!--      <template v-slot:extension>-->
        <v-layout column  v-if="groupId" style="box-shadow: inset 0 0 18px deepskyblue;">
          <v-flex xs12 px-2 ma-0>
            <v-toolbar  dense flat style="width:100%;" class="user-coins-details" color="transparent">
              <v-toolbar-title class="ml-0 subheading ">
              <span class="ml-1">
                <font-awesome-icon
                  class="ml-1 left yellow--text text--lighten-1"
                  :icon="['fas', 'coins']"
                  style="font-size: 16px;margin-top:3px;" />&nbsp;
                Coins</span>
                <span class="ml-1 font-weight-bold current-step">{{tokens}}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <span class="ml-1">Your Activity</span>
              <span class="ml-1 font-weight-bold">{{activityCounter}}</span>
            </v-toolbar>
          </v-flex>
        </v-layout>
<!--      </template>-->


      <v-list class="pt-0 primary darken-1" dense>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-action >
            <v-icon>schedule</v-icon>
          </v-list-tile-action>

          <v-list-tile-content >
            <v-list-tile-title>

              <span v-text="humanTime" class="mr-1 font-weight-bold yellow--text subheading"/><span class="font-weight-bold">Hrs</span> of activity today</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <div v-for="(item, index) in items"
             :key="item.routeName">

        <v-list-group
          v-if="typeof item.items !== 'undefined' && item.isActive === true && item.isActive === true"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.routeName"
            @click="openRoute(subItem.routeName)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <font-awesome-icon
                v-if="subItem.iconFamily === 'fontAwesome'"
                :icon="subItem.icon" style="font-size: 22px;" />
              <v-icon v-else>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

          <v-list-tile
            v-if="item.routeName &&
            typeof item.items === 'undefined' &&
            item.isActive === true "
            :key="item.routeName" :class="item.routeName === $route.name ? 'selectedRoute' :'' "
            @click="openRoute(item.routeName)"
          >
            <v-list-tile-action >
              <font-awesome-icon
                v-if="item.iconFamily === 'fontAwesome'"
                :icon="item.icon" style="font-size: 22px;" />
              <v-icon v-else>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-subheader v-else-if="item.header" :key="item.header" class="grey--text text--lighten-4">
            {{ item.header}}
          </v-subheader>
        </div>
      </v-list>
      <div style="bottom:0;right:0;position:fixed;"
           class="px-2 grey--text text--lighten-1">Build: v{{version}}</div>
    </v-navigation-drawer>
  </div>
</template>

<script>
  const packageConfig = require('../../../package.json')
  function secondsToTime (e) {
    const h = Math.floor(e / 3600).toString().padStart(2, '0')
    const m = Math.floor(e % 3600 / 60).toString().padStart(2, '0')
    // const s = Math.floor(e % 60).toString().padStart(2, '0')
    return `${h}:${m}`
  }
  export default {
    name: 'NavigationMenu',
    components: {
    },
    data () {
      return {
        apiUrl: process.env.API_URL,
        humanTime: 0,
        totalSeconds: 1,
        version: packageConfig.version,
        right: true,
        hasAvatar: true,
        groupId: parseInt(this.$route.params.groupId),
        deckId: parseInt(this.$route.params.deckId),
        siteUrl: process.env.SITE_URL,
        items: [
          {
            icon: 'home',
            iconFamily: 'material',
            routeName: 'ProgramLevels',
            title: 'Home',
            isActive: true
          },
          { divider: true },
          {
            icon: 'settings',
            iconFamily: 'material',
            routeName: 'Settings',
            title: 'My Settings',
            isActive: true
          },
          { divider: true },
          {
            icon: 'navigation',
            iconFamily: 'material',
            routeName: 'QuickStart',
            title: 'Quick Start',
            isActive: typeof this.$route.params.groupId !== 'undefined' &&
            typeof this.$route.params.deckId !== 'undefined' && this.$route.name === 'ProgramLevels'
          },
          { divider: true },
          {
            icon: 'navigation',
            iconFamily: 'material',
            routeName: 'QuickStartLearn',
            title: 'Quick Start',
            isActive: this.$route.name === 'Learn'
          },
          // { divider: true },
          // {
          //   icon: ['far', 'clone'],
          //   iconFamily: 'fontAwesome',
          //   routeName: 'Programs',
          //   title: 'My Programs',
          //   isActive: true
          // },
          { divider: true },
          {
            icon: 'description',
            iconFamily: 'material',
            routeName: 'Programs',
            title: 'Useful Links',
            isActive: true,
            items: [
              {
                icon: 'description',
                iconFamily: 'material',
                routeName: 'CertificateProgram',
                title: 'Certificate Program'
              },
              // {
              //   icon: 'question_answer',
              //   iconFamily: 'material',
              //   routeName: 'Faq',
              //   title: 'Frequently Asked Questions'
              // },
              {
                icon: 'policy',
                iconFamily: 'material',
                routeName: 'PrivacyPolicy',
                title: 'Privacy Policy'
              }, {
                icon: 'security',
                iconFamily: 'material',
                routeName: 'TermsOfUse',
                title: 'License & Terms of Use'
              }, {
                icon: 'description',
                iconFamily: 'material',
                routeName: 'AnsiAccreditation',
                title: 'ANSI Accreditation'
              }, {
                icon: 'contact_support',
                iconFamily: 'material',
                routeName: 'ContactSupport',
                title: 'Contact Support'
              }
            ]
          },
          { divider: true },
          {
            icon: 'power_settings_new',
            iconFamily: 'material',
            routeName: 'Exit',
            title: 'Sign Out',
            isActive: true
          },
          { divider: true }]
      }
    },
    computed: {
      tracking () {
        return this.$store.getters['user/getTracking']
      },
      levelGroupDetails () {
        let groupId = this.$route.params.groupId
        return this.groups.find(group => {
          return parseInt(group.groupId) === parseInt(groupId)
        })
      },
      tokens: {
        get: function () {
          if (typeof this.group !== 'undefined' && typeof this.group.tokens !== 'undefined') {
            return parseInt(this.group.tokens)
          } else {
            return 0
          }
        },
        set: function () {
        }
      },
      activityCounter: {
        get: function () {
          return parseInt(this.group.activityCounter)
        },
        set: function () {
        }
      },
      rightDrawer: {
        get: function () {
          return this.$store.getters.rightDrawer
        },
        set: function (value) {
          this.$store.commit('toggleRightDrawer', value)
        }
      },
      isAuth () {
        return this.$auth.check()
      },
      userDetails () {
        return this.$store.getters['user/getUserDetails']
      },
      uname () {
        return this.$store.getters['user/userFullName']
      },
      avatarLetters () {
        return this.$store.getters['user/avatarLetters']
      },
      groups: {
        get: function () {
          return this.$store.getters['course/getGroups']
        },
        set: function (val) {
          // this.group = val.find(group => parseInt(group.groupId) === this.groupId)
        }
      },
      group: {
        get: function () {
          return this.groups.find(group => parseInt(group.groupId) === this.groupId)
        },
        set: function () {
        }
      }
    },
    created () {
      this.getTimeElapsed()
      setInterval(() => {
        this.getTimeElapsed()
      }, (5 * 60 * 1000))

      setInterval(() => {
        if (this.tracking) {
          this.totalSeconds += 1
        }
        this.updateTime()
      }, 1000)
    },
    methods: {
      getTimeElapsed () {
        const GAME_ID = process.env.GAME_ID
        // console.log('this.$store.getters.getUserDetails', this.$store.getters['user/getUserDetails'])
        if (this.$store.getters['user/getUserDetails'].id) {
          const USER_ID = this.$store.getters['user/getUserDetails'].id
          this.$http({
            url: `${this.apiUrl}/ws/tracking/time/user/${USER_ID}/course/${GAME_ID}`,
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
            }
          }).then((res) => {
            if (res.status === 204) {
              this.totalSeconds = 1
            }
            if (res.status === 200) {
              this.totalSeconds = res.data.duration * 60
            }
          })
        }
      },
      updateTime () {
        // this.$store.commit('user/setTimer', {total: this.totalSeconds + 1})
        this.humanTime = secondsToTime(this.totalSeconds)
      },
      checkRouteForHome (item) {
        if (item.routeName === 'ProgramLevels') {
          if (isNaN(this.groupId) || isNaN(this.deckId)) {
            return false
          } else {
            return true
          }
        } else if (item.routeName === 'Programs') {
          if (this.groups.length > 1) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      openProgramLevel (deckId, groupId) {
        this.rightDrawer = false
        this.$router.push({name: 'ProgramLevels', params: {deckId, groupId}})
      },
      openRoute (route) {
        this.rightDrawer = false
        if (route === 'Exit') {
          this.$store.commit('user/setUserDetails', {})
          this.$store.commit('flashSuccess', 'Logout successfully')
          localStorage.removeItem('avatar')
          document.cookie = 'user_name=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
          document.cookie = 'user_email=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
          document.cookie = 'auth_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
          this.$auth.logout({
            redirect: '/',
            makeRequest: false
          })
        } else if (route === 'ProgramLevels') {
          // this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId, groupId: this.groupId}})
          this.$router.push({name: 'Home'})
        } else if (route === 'QuickStart') {
          this.$store.commit('setDashboardTourStart', new Date().getTime())
          this.$router.push({
            name: 'ProgramLevels',
            query: { tour: 'start' },
            params: { deckId: this.deckId, groupId: this.groupId }})
        } else if (route === 'QuickStartLearn') {
          // this.$store.commit('setDashboardTourStart', new Date().getTime())
          this.$router.replace({ query: { learntour: 'start' } })
        } else if (route === 'TodayNews') {
          this.$store.commit('setAllNewsDialog', true)
          // this.$store.commit('setUserSeenNewsOnDate', '')
        } else if (route === '/') {
          const route = Object.keys(this.userDetails).length > 0 ? 'Programs' : 'Home'
          this.$router.push({name: route})
        } else {
          this.$router.push({name: route})
        }
      }
    },
    watch: {
      // userDetails () {
      //   this.getTimeElapsed()
      // }
    }
  }
</script>
<style scoped lang="stylus">
  .selectedRoute {
    background : rgba(255,255,255,0.12)
    cursor: default
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/NavigationMenu.vue